
import { Directive, HostListener, inject } from '@angular/core';
import { Location } from '@angular/common';

@Directive({
  selector: '[appSwipeBack]',
  standalone: true
})
export class SwipeBackDirective {
  private readonly location = inject(Location);

  // Thresholds
  private readonly EDGE_THRESHOLD = 50; // px from the left edge
  private readonly SWIPE_THRESHOLD = 100; // min swipe distance in px
  private readonly MAX_VERTICAL_SWIPE = 75; // max vertical movement allowed

  // Tracking state
  private touchStartX = 0;
  private touchStartY = 0;
  private isSwiping = false;

  @HostListener('touchstart', ['$event'])
  onTouchStart(event: TouchEvent): void {
    this.touchStartX = event.changedTouches[0].screenX;
    this.touchStartY = event.changedTouches[0].screenY;

    // Only start tracking if the swipe begins near the left edge
    if (this.touchStartX < this.EDGE_THRESHOLD) {
      this.isSwiping = true;
    } else {
      this.isSwiping = false;
    }
  }

  @HostListener('touchend', ['$event'])
  onTouchEnd(event: TouchEvent): void {
    if (!this.isSwiping) {
      return;
    }

    const touchEndX = event.changedTouches[0].screenX;
    const touchEndY = event.changedTouches[0].screenY;

    const horizontalSwipeDistance = touchEndX - this.touchStartX;
    const verticalSwipeDistance = Math.abs(touchEndY - this.touchStartY);

    // Reset for next swipe
    this.isSwiping = false;

    // Check if the swipe meets the criteria
    if (
      horizontalSwipeDistance > this.SWIPE_THRESHOLD &&
      verticalSwipeDistance < this.MAX_VERTICAL_SWIPE
    ) {
      this.location.back();
    }
  }

  @HostListener('touchcancel', ['$event'])
  onTouchCancel(event: TouchEvent): void {
    // Reset if the touch event is cancelled by the browser
    this.isSwiping = false;
  }
}
